import { convertQueryCommandToQueryString, IQueryCommandOptions, mergeQueryCommandOptions } from '@llws/dynamic-router-utils';

interface IAgentsOptionsForClientPathOptions {
  isToursRestricted: boolean,
  adminGatewayPath: string,
  agentGatewayPath: string,
  baseQuery: IQueryCommandOptions,
  payload?: IQueryCommandOptions,
}

/**
 * Builds the request path for the client's Tour Agent picker options.
 *
 * Tours admins use tour-api's `tour-agent-options` endpoint, which leaves out former agents and
 * takes the client from the auth identity, so the base query and payload don't apply to it.
 * Restricted users keep the generic `tour_user_settings` request through the agent gateway. Its
 * query merges the base and payload so the caller's `where` doesn't replace the base `where`.
 * @param options.isToursRestricted Whether the user is a tours agent without tours admin access
 * @param options.adminGatewayPath Tour-api path on the admin gateway
 * @param options.agentGatewayPath Tour-api path on the agent gateway
 * @param options.baseQuery The store's base query for the restricted request
 * @param options.payload The caller's query for the restricted request
 * @returns The path, with its query string for the restricted request
 */
export const buildAgentsOptionsForClientPath = ({
  isToursRestricted, adminGatewayPath, agentGatewayPath, baseQuery, payload,
}: IAgentsOptionsForClientPathOptions): string => {
  if (!isToursRestricted) {
    return `${adminGatewayPath}/tour-agent-options`;
  }

  const query = mergeQueryCommandOptions([baseQuery, payload ?? {}]);
  return `${agentGatewayPath}/tour_user_settings${convertQueryCommandToQueryString(query)}`;
};
